import { useTranslation } from '@cobliteam/i18n';
import { FormControl, FormField, FormItem, FormLabel, FormMessage, Input, useFormContext } from '@cobliteam/ui/form';

import type { FormValues } from '../checklistSchema';

const ChecklistName = () => {
  const { t } = useTranslation('checklists');
  const { control } = useFormContext<FormValues>();

  return (
    <FormField control={control} name='name'>
      {({ field, formState }) => (
        <FormItem>
          <FormLabel>{t('checklist_name')}</FormLabel>
          <FormControl>
            <Input {...field} placeholder={t('define_checklist_name')} error={!!formState.errors.name} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    </FormField>
  );
};

export default ChecklistName;
